import { Component, OnInit } from '@angular/core';
import { CommonActionPanelComponent } from '../../../common/common-action-panel-component.directive';
import { RuleInterface } from '@vendasta/automata';
import { FormGroup, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { StaticSelectorService } from '../../../../../data-services/static-selector.service';
import { AutomationReplacementChipsComponent } from '../../../../../common/components';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { startWith } from 'rxjs/operators';

// pipeline statuses keys
export enum OpportunityStatus {
  ClosedWon = 'closed-won',
  ClosedLost = 'closed-lost',
}

// opportunity close lost reasons
export enum CloseLostReason {
  Price = 'price',
  NoBudget = 'no-budget',
  LostToCompetitor = 'lost-to-competitor',
  NotReady = 'not-ready',
  Other = 'other',
}

@Component({
  selector: 'automata-close-opportunity-panel',
  imports: [AutomationReplacementChipsComponent, FormsModule, ReactiveFormsModule, CommonModule],
  templateUrl: './close-opportunity-panel.component.html',
  styleUrl: './close-opportunity-panel.component.scss',
})
export class CloseOpportunityPanelComponent extends CommonActionPanelComponent implements OnInit {
  OpportunityStatus = OpportunityStatus;

  form: UntypedFormGroup;

  opportunityStatusControl: FormControl;
  closedLostReasonControl: FormControl;

  opportunityStatusOptions = new Map<string, string>([
    [OpportunityStatus.ClosedWon, 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.STATUS_OPTIONS.CLOSED_WON'],
    [OpportunityStatus.ClosedLost, 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.STATUS_OPTIONS.CLOSED_LOST'],
  ]);

  closedLostReasonOptions = new Map<string, string>([
    [CloseLostReason.Price, 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.CLOSED_LOST_REASON_OPTIONS.PRICE'],
    [CloseLostReason.NoBudget, 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.CLOSED_LOST_REASON_OPTIONS.NO_BUDGET'],
    [
      CloseLostReason.LostToCompetitor,
      'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.CLOSED_LOST_REASON_OPTIONS.LOST_TO_COMPETITOR',
    ],
    [CloseLostReason.NotReady, 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.CLOSED_LOST_REASON_OPTIONS.NOT_READY'],
    [CloseLostReason.Other, 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.CLOSED_LOST_REASON_OPTIONS.OTHER'],
  ]);

  opportunityStatusDataService = new StaticSelectorService<string>(
    this.opportunityStatusOptions,
    this.translateService,
  );

  closedLostReasonDataService = new StaticSelectorService<string>(this.closedLostReasonOptions, this.translateService);

  constructor(protected readonly translateService: TranslateService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.opportunityStatusControl = new FormControl<string>(OpportunityStatus.ClosedWon, Validators.required);
    this.closedLostReasonControl = new FormControl<string>(CloseLostReason.Other);

    const jsonData = this.step ? JSON.parse(this.step.data) : null;
    if (jsonData) {
      this.opportunityStatusControl.setValue(jsonData.status);
      this.closedLostReasonControl.setValue(jsonData.closed_reason);
    }

    this.form = new FormGroup({
      opportunityStatusControl: this.opportunityStatusControl,
      closedReasonControl: this.closedLostReasonControl,
    });

    this.form.valueChanges.pipe(startWith(null)).subscribe(() => {
      this.savingEnabled = !this.form.invalid && this.isFormValid();
    });
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [];
  }

  getData(): any {
    return {
      status: this.opportunityStatusControl.value,
      closed_reason: this.closedLostReasonControl.value,
    };
  }

  getRules(): RuleInterface[] {
    return [];
  }

  isFormValid(): boolean {
    return true;
  }
}
